class FeeCollectionMethods {
    static ServiceFeeAndTelematicsOnInvestorBill : string = "ServiceFeeAndTelematicsOnInvestorBill";
    static ServiceFeeAndTelematicsOnAssetOperatorBill : string = "ServiceFeeAndTelematicsOnAssetOperatorBill";
}

export { FeeCollectionMethods }
